// extracted by mini-css-extract-plugin
module.exports = {"root":"b1ddd01198--root--YZmcL","description":"b1ddd01198--description--RRmaW","amenities":"b1ddd01198--amenities--kYKCj","amenities-group":"b1ddd01198--amenities-group--O844v"};